import { Injectable } from '@angular/core';
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(private configService: ConfigService,
    private networkService: NetworkService) { }

  public getAuthToken(code, urlRef) {
    return this.networkService.getRequest(this.configService.getAuthToken(code, urlRef));
  }

  public getAuthTokenByRefreshToken(refreshToken) {
    return this.networkService.getRequest(this.configService.getAuthTokenByRefreshToken(refreshToken));
  }

  public getOAuthSettings(urlRef) {
    return this.networkService.getRequest(this.configService.getOAuthSettings(urlRef));
  }
}
